'use strict';

const angular = require('angular');

require('./editPrecondition.html');

module.exports = angular
  .module('spinnaker.core.pipeline.config.preconditions.modal.controller', [])
  .controller('EditPreconditionController', function ($scope, $uibModalInstance, precondition, strategy, application) {
    var vm = this;

    vm.strategy = strategy;
    vm.application = application;
    vm.precondition = angular.copy(precondition);
    vm.submit = function () {
      $uibModalInstance.close(vm.precondition);
    };

    return vm;
  });



// WEBPACK FOOTER //
// ./app/scripts/modules/core/src/pipeline/config/preconditions/modal/editPrecondition.controller.modal.js